import AddNewVendorsForm from "./AddNewVendorsForm";
import AddNewVendorsHeader from "./AddNewVendorsHeader";

export { AddNewVendorsForm, AddNewVendorsHeader };
